// Cüzdan işlemleri (Bakiye Yükleme + Satış) sayfalarının paylaşılan UI parçaları.

// Renkler işletme bakışıyla (#242): satış başarılı gelirdir → yeşil, kırmızı
// değil. Başarı/başarısızlık ayrı STATUS_BADGE'de. Kırmızı yalnız hata içindir.
export const TYPE_BADGE = {
  topup: {
    label: "Yükleme",
    bg: "bg-blue-100",
    text: "text-blue-700",
    sign: "+",
    amount: "text-blue-600",
  },
  payment: {
    label: "Satış",
    bg: "bg-emerald-100",
    text: "text-emerald-700",
    sign: "",
    amount: "text-gray-900",
  },
  refund: {
    label: "İade",
    bg: "bg-orange-100",
    text: "text-orange-700",
    sign: "-",
    amount: "text-orange-600",
  },
};

export const STATUS_BADGE = {
  success: { label: "Başarılı", bg: "bg-green-100", text: "text-green-700", dot: "bg-green-500" },
  pending: { label: "Bekleyen", bg: "bg-yellow-100", text: "text-yellow-700", dot: "bg-yellow-500" },
  failed: { label: "Başarısız", bg: "bg-red-100", text: "text-red-700", dot: "bg-red-500" },
};

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return d.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTL(amount) {
  if (amount == null) return "-";
  return (
    Number(amount).toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " ₺"
  );
}

function getUserInfo(user) {
  if (!user) return { fullName: "-", email: "", tel: "", initials: "?" };
  const fullName = [user.name, user.lastName].filter(Boolean).join(" ") || "-";
  const initials =
    ((user.name || "").trim().charAt(0) + (user.lastName || "").trim().charAt(0))
      .toUpperCase() || "?";
  return {
    fullName,
    email: user.email || "",
    tel: user.tel || "",
    initials,
  };
}

// İsim + soyisim + e-posta'yı avatar (baş harfler) ile gösteren hücre.
export function UserCell({ user, compact = false }) {
  const info = getUserInfo(user);
  const avatarSize = compact ? "w-8 h-8 text-[11px]" : "w-9 h-9 text-xs";
  return (
    <div className="flex items-center gap-2.5 min-w-0">
      <div
        className={`${avatarSize} rounded-full bg-primary/25 text-main flex items-center justify-center font-bold shrink-0`}
      >
        {info.initials}
      </div>
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900 truncate">
          {info.fullName}
        </div>
        {info.email ? (
          <div className="text-xs text-gray-500 truncate">{info.email}</div>
        ) : info.tel ? (
          <div className="text-xs text-gray-500 truncate">{info.tel}</div>
        ) : null}
      </div>
    </div>
  );
}

export function TypeBadge({ txType }) {
  const badge = TYPE_BADGE[txType] || TYPE_BADGE.payment;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}
    >
      {badge.label}
    </span>
  );
}

export function StatusBadge({ status }) {
  const badge = STATUS_BADGE[status] || STATUS_BADGE.pending;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${badge.dot}`} />
      {badge.label}
    </span>
  );
}

export function AmountText({ tx, className = "" }) {
  const badge = TYPE_BADGE[tx.txType] || TYPE_BADGE.payment;
  return (
    <span className={`font-semibold ${badge.amount} ${className}`}>
      {badge.sign}
      {formatTL(tx.amountTL)}
    </span>
  );
}
